import type { useTranslation } from 'react-i18next';
import { appErrorCode } from '~/lib/app-error';

/**
 * Why a call could not be placed, in the desk's words.
 *
 * One mapper for both Call buttons — the dialer in the phone panel and the one
 * on a contact. Matched on codes rather than wording: two copies of the ladder
 * both went stale when `openOutboundCall` was reworded, and every failure read
 * as the generic message with three translated ones unreachable.
 *
 * There is deliberately no "line is busy": nothing refuses a busy line — the
 * dial goes out and the handset decides.
 *
 * `ns` at every call because `t` arrives as a parameter, and the extractor
 * reads the call rather than what the caller bound it to.
 */
export function callErrorMessage(
  error: unknown,
  t: ReturnType<typeof useTranslation<'tasks'>>['t'],
) {
  switch (appErrorCode(error)) {
    case 'no_line':
      return t('No SIP line assigned', { ns: 'tasks' });
    case 'line_has_no_number':
      return t('Your line has no number to call from', { ns: 'tasks' });
    case 'contact_has_no_number':
      return t('Contact has no phone number', { ns: 'tasks' });
    default:
      return t('Could not start the call', { ns: 'tasks' });
  }
}
